import img2 from "../../textiles_png/6_textiles/six_other/6_saddle.png";
import img3 from "../../textiles_png/6_textiles/six_other/6B1_keift_saddle.png";
import img4 from "../../textiles_png/6_textiles/six_other/6_map.png";
import img5 from "../../textiles_png/6_textiles/six_other/6_three.png";
import img6 from "../../textiles_png/6_textiles/six_other/6_four.png";
import img7 from "../../textiles_png/6_textiles/6B2_12504.png";

export const sixObj = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "Classic Period Saltillo Sarapes",
  description:
    "Researchers refer to the time when earliest examples of Saltillo sarapes were produced as the Classic period (1720–1860). Sarapes of this era were meticulously woven using hand-spun wool, which was naturally dyed, often with cochineal and indigo. The use of the red dye from cochineal signified wealth and prestige. Sarape designs strictly adhered to the three-part system of a central diamond or circular medallion, on an often-intricate background, with a distinctive border.",
  description2: "",
  buttonLabel: "",
  block: true,
  imgStart: false,
  imgdesc: "",
  img: img5,
  alt: "One",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: false,
};

export const sixObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "Transition Period Saltillo Sarapes",
  description:
    "By the mid-1800s, the Saltillo sarape had gained fame internationally. The fineness of the weaving, the detailed patterns, and the rich red and deep-blue dyes were appreciated around the world. Perhaps in response to the global market, weavers started to slightly alter their designs. Technological and chemical advances brought commercially produced yarns and dyes to the weavers’ workshops.After 1850, weavers started to use machine-spun yarn, some imported from Europe, which had been dyed with synthetic, coal-tar aniline dyes. As a result, unusual combinations of machine-spun and hand-spun yarn, and natural and synthetic dyes, often appear in the same piece.",
  description2:
    "The Transition period, from 1860 to 1900, saw the introduction of brighter colors and an expansion in design motifs, including a multi-diamond pattern and motifs from France and other European countries. Flowers, animals, motifs from classical architecture, portraits, and other representational elements appear in sarapes, often combined in unusual ways with traditional patterns.",
  buttonLabel: "",
  block: true,
  imgStart: false,
  imgdesc: "",
  img: img6,
  alt: "One",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: false,
};

export const sixObjTwo = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "Transition Period Saltillo Sarapes",
  description: "",
  description2: "",
  buttonLabel: "",
  block: true,
  imgStart: false,
  imgdesc: "",
  img: img2,
  imgdesc2:
    "Mexican saddle C. 1860–1900On loan from Michael D. Higgins AT-2020-14-1",
  img3: img7,
  alt: "",
  imgdesc4:
    "Post-Classic period Saltillo sarape, c. 1870 Wool, cotton, and indigo and possibly synthetic dyes 12504",
  img2: img3,
  alt2: "",
  imgdesc3:
    "Photographer unknown Published by Gevaey for FotoMex, c. 1910 Collection of Tom Kieft",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: true,
};

export const sixObjThree = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: false,
  topLine: "",
  headline: "The Regional Styles",
  description:
    "By the 1900s, many weavers in Mexico and New Mexico had developed styles unique to their regions or workshops. Regional weaving centers were established in the cities of Saltillo, Puebla, Tlaxcala, Texcoco, San Miguel de Allende, Guanajuato, and, of course, Teotitlán del Valle in Oaxaca, among others. The textiles were woven on treadle looms using both natural and synthetic-dyed yarn.",
  description2:
    "Oaxacan sarapes of the late 1800s and early 1900s feature either a central diamond or a circular center design. They have patterned and plain backgrounds, as well as borders. Banded stripes are often woven along the ends. Oaxacan sarapes usually have warps and wefts made of wool. In comparison, sarapes woven in other areas of Mexico usually have warp threads of finely spun cotton that are completely covered by tightly packed woolen weft threads.",
  buttonLabel: "",
  block: true,
  imgStart: false,
  imgdesc: "",
  img: img4,
  alt: "One",
  imgdesc2: "REGIONAL WEAVING CENTERS",
  img2: " ",
  alt2: "One",
  imgdesc3: "",
  dark: true,
  primary: true,
  darkText: false,
  smallImg: false,
};
